<!-- 
Component: CheckboxWithLabel
Use this when you want a CSS-enabled checkbox that adheres to WCAG guideline 2.1.1
-->
<template>
  <div class="form-check">
    <input class="form-check-input" type="checkbox" :id="checkboxId" @change="onChange" />
    <label class="form-check-label paragraph-reduced" :for="checkboxId" tabindex="0" @keydown="onChangeKeyEvent">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  data(){
    return{
      checkboxId : null
    }
  },
  methods: {
    onChange(event) {
      this.$emit("checkboxChange", event.target.checked);
    },
    onChangeKeyEvent(event){
      if (event.keyCode == 32 || event.keyCode == 13) {
        event.preventDefault();
        var checkbox = $("#" +this.checkboxId)[0]
        checkbox.checked = !checkbox.checked
        event.target.checked = checkbox.checked
        this.onChange(event)
      }
    },
    resetForm()
      {
      const checkbox = $("#" +this.checkboxId)[0]
      /**
      * Ticket:   RP-170
      * Date:     2021-05-19
      * Author:   Joseph Ricohermoso
      * Desc:     Reset the payment section when moving back end fort from other pages
      */
      if (checkbox.checked)
        {
        checkbox.checked = false;
        }
      }
  },
  mounted(){
    this.checkboxId = "checkboxWithLabel" + this._uid
  }
};
</script>